<template>
  <div class="tab-content d-flex justify-space-between align-start">
    <div class="tab-content-text d-flex flex-column ga-8">
      <div class="identidade-visual config-group-title d-flex flex-column ga-4">
        <h2 class="title-medium">Identidade visual</h2>
        <div class="identidade-visual-content d-flex flex-column ga-4">
          <rb-input v-model="localData.name" :rules="[...inputRules.required, ...inputRules.maxLength(4000)]" required placeholder="Meu assistente"
            label="Nome do assistente *"></rb-input>
          <rb-input v-model="localData.institute" :rules="[...inputRules.required, ...inputRules.maxLength(4000)]" required placeholder="Organização"
            label="Nome da Organização *"></rb-input>
          <div class="label-large">
            <p class="mb-4">Cor do assistente</p>
            <ColorPicker v-model="localData.color"></ColorPicker>
          </div>
          <div class="label-large">
            <p class="mb-4">Imagem do assistente</p>
            <ImageSelector v-model="localData.image"></ImageSelector>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column ga-4">
        <h2 class="title-medium">Objetivo</h2>
        <div class="d-flex flex-column ga-4">
          <rb-textarea
            v-model="localData.speciality"
            rows="3"
            :rules="[...inputRules.required, ...inputRules.maxLength(4000)]"
            required
            label="Descreva a especialidade do seu assistente *"
            hint='Exemplo: "Um assistente que ajuda as pessoas a atingirem seus objetivos, desenvolverem novas habilidades e superarem desafios."'
            persistent-hint
          ></rb-textarea>

          <rb-textarea
            v-model="localData.values"
            rows="3"
            :rules="[...inputRules.required, ...inputRules.maxLength(4000)]"
            required
            label="Defina o que sua IA oferece e valoriza *"
            hint='Exemplo: "Soluções personalizadas e suporte contínuo."'
            persistent-hint
          ></rb-textarea>
        </div>
      </div>
    </div>
    <CardBaseConhecimentos :relatedLinks="relatedLinks"></CardBaseConhecimentos>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue';
import ColorPicker from '@/ai_studio/components/common/ColorPicker.vue';
import ImageSelector from '@/ai_studio/components/common/ImageSelector.vue';
import CardBaseConhecimentos from '@/assistents/components/CardBaseConhecimentos.vue';

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  },
  relatedLinks: {
    type: Array,
    required: true
  },
  inputRules: {
    type: Object,
    required: true
  }
});

const localData = computed({
  get: () => props.modelValue,
  set: (newValue) => {
    emit('update:modelValue', newValue);
  }
});
</script>

<style lang="scss" scoped>
@use '@/ai_studio/styles/components/assistents-configuration.scss';
</style>